import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ProjectService, TenantService, UserService} from '../../_services/index';

import {Router} from '@angular/router';

//import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Project, User} from '../../_models/index';

import {Role} from '../../helpers/role';

import {Table} from "primeng/table";
import {forkJoin} from "rxjs";
import {LoginHelper} from "../../helpers";
import {ImportSspComponent} from "../importSsp/importSsp.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MenuItem} from "primeng/api";
import {ImportOscalComponent} from "../importOscal/importOscal.component";

@Component({
    standalone: false,
  selector: "projects",
  templateUrl: 'projects.component.html',
  styleUrls: ['./projects.component.scss'],
})

export class ProjectsComponent implements OnInit {

  @ViewChild('table') table: Table;
  projects: Project[] = [];
  ownerItems: any[] = [];

  canCreateProject: boolean;
  canClone: boolean;
  currentUser: User;
  menuItems: MenuItem[];
  selectedItem: Project;
  users: User[];
  cols : any[] = [
    {field: 'name', header: 'Name', width: '12em'},
    {field: 'status', header: 'Status, % Implemented'},
    {field: 'dueDate', header: 'Due Date'},
    {field: 'itemsRemaining', header: '# Remaining/All Items'}
  ];
  isAutonomyEnabled: boolean = false;

  constructor(
    public dialog: MatDialog,
    public projectService: ProjectService,
    public router: Router,
    public alertService: AlertService,
    public userService: UserService,
    public tenantService: TenantService,
    public authenticationService: AuthenticationService) {
  }

  ngOnInit() {

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canCreateProject = (this.currentUser.role & Role.PrimaryManager) != 0
      || (this.currentUser.role & (Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;

    this.menuItems = [
      {label: 'Open', icon: 'pi pi-pencil', command: (event) => this.openProject(this.selectedItem.projectId)}
    ];

    this.tenantService.getCurrent().subscribe(p => {
      this.canClone = p.isCloneEnabled;
      this.isAutonomyEnabled = p.isAutonomyEnabled;
    });

    this.loadAllProjects();
  }

  public loadAllProjects() {

    const prjs: any = this.projectService.getUsersAllProjects(this.currentUser.userId);

    forkJoin(prjs, this.userService.getAllShort(LoginHelper.getTenantName())).subscribe(data => {
        const projects = data[0];
        this.users = data[1];
        this.projects = <Project[]>projects;
        this.ownerItems = (<Project[]>projects).map(p => p.ownerName = this.getProjectOwner(p)).filter((v, i, s) => s.indexOf(v) == i).sort().map(i => {
          return {'label': i, 'value': i}
        })
        this.ownerItems.unshift({label: '', value: ''});

        this.projects.forEach(
          proj => proj.status = Math.floor(
            ((proj.itemsCount - proj.itemsRemaining) / proj.itemsCount) * 100));
      },

      error => {
        const errorMessage = 'An error occurred while loading projects.';
        this.alertService.error(errorMessage);
      });
  }

  openProject(projectId: number) {
    this.router.navigate(['/projects/project', projectId]);
  }

  createProject() {
    this.router.navigate(['/projects/project/create']);
  }

  openImportSsp() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '20%',
      height: 'auto',
    };
    const dialogRef = this.dialog.open(ImportSspComponent, config);
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadAllProjects();
      }
    });
  }

  openImportOscal() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '20%',
      height: 'auto',
    };
    const dialogRef = this.dialog.open(ImportOscalComponent, config);
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadAllProjects();
      }
    });
  }

  getProjectOwner(project: Project): string {
    const tenantManager = this.users.find(x => x.userId == project.createdBy);
    if (tenantManager != null) {
      return this.getFullName(tenantManager);
    }
    return '';
  }

  getFullName(user: User): string {

    if (user.firstName != null && user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }
}
